import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAuth, useIsPlatformAdmin } from '../../../hooks/useAuth'
import { useBreadcrumbs } from '../../../hooks/useBreadcrumbs'
import { PageHeader } from '../../../components/shared/PageHeader'
import { SECTION_ICONS } from '../../../lib/section-icons'
import { BillingPricesSection } from '../../../components/admin/BillingPricesSection'

export const Route = createFileRoute('/admin/billing/prices')({
  component: RouteComponent,
})

// The list price: it reaches every customer without its own row, from its
// month (spec 2026-10-05-13). Platform admins only.
function RouteComponent() {
  const { t } = useTranslation('admin')
  const { loading, orgCode } = useAuth()
  const isPlatformAdmin = useIsPlatformAdmin()
  const navigate = useNavigate({ from: '/admin/billing/prices' })

  useEffect(() => {
    if (!loading && !isPlatformAdmin) {
      navigate({ to: '/', replace: true })
    }
  }, [loading, isPlatformAdmin, navigate])

  const breadcrumbOrg = orgCode || 'demo'
  useBreadcrumbs([
    { title: t('common:nav.home'), path: `/${breadcrumbOrg}` },
    { title: t('settings:page.title'), path: `/${breadcrumbOrg}/settings` },
    { title: t('billing.title'), path: '/admin/billing' },
    { title: t('billing.prices.list_title') },
  ])

  if (loading || !isPlatformAdmin) {
    return null
  }

  return (
    <div className="space-y-6" data-testid="admin-billing-prices-page">
      <PageHeader
        icon={SECTION_ICONS.adminBilling}
        title={t('billing.prices.list_title')}
        description={t('billing.prices.list_subtitle')}
      />
      <BillingPricesSection />
    </div>
  )
}
